import fetchSubscriptionIfNeeded from '../../actions/connectors/fetchSubscriptionIfNeeded';
import connectAsync from '../../utils/connectAsync';
import PaymentInformationRoute from './PaymentInformationRoute';

export default connectAsync([fetchSubscriptionIfNeeded])(PaymentInformationRoute);
